<template>
  <header class="global-header" v-if="getAgencyDisplay">

    <div class="header-eyebrow" v-if="!isBookPage">
      <div class="container">
        <AdminNavigation v-if="currentUser" />

        <div class="changers">
          <CurrencyChanger></CurrencyChanger>
          <LocaleChanger></LocaleChanger>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="header-content">
        <div class="logo">
          <span v-if="getAgencyMenus.bookingPlatform.logoLink.link.startsWith('http')">
            <a :href="getAgencyMenus.bookingPlatform.logoLink.link" :title="getAgencyMenus.bookingPlatform.logoLink.title">
              <img :src="getAgencyDisplay.logoUrl" alt="" v-if="getAgencyDisplay.logoUrl" />
              <img src="../assets/img/logo.png" alt="" v-else />
            </a>
          </span>
          <span v-else>
            <router-link :to="`/${$i18n.locale}/`" title="Home">
              <img :src="getAgencyDisplay.logoUrl" alt="" v-if="getAgencyDisplay.logoUrl" />
              <img src="../assets/img/logo.png" alt="" v-else />
            </router-link>
          </span>
        </div>

        <GlobalNavigation :currentUser="currentUser" :isBookPage="isBookPage" />

      </div>
    </div>
  </header>
</template>

<script>

import {auth} from "@/firebaseConfig";
import AdminNavigation from '@/components/AdminNavigation'
import LocaleChanger from '@/components/LocaleChanger'
import CurrencyChanger from '@/components/CurrencyChanger'
import { mapGetters } from 'vuex'


export default {
  name: 'GlobalHeader',

  data() {
    return {
      
    }
  },

  components: {
    AdminNavigation,
    LocaleChanger,
    CurrencyChanger
  },

  methods: {
    
  },

  computed: {
    ...mapGetters ([
      'getAgencyDisplay',
      'getAgencyMenus'
    ]),

    isAdminPage: function() {
      if (this.$route.path.includes('admin')) {
        return true
      } else {
        return false
      }
    },

    isBookPage: function() {
      if (this.$route.path.includes('book') && !this.$route.path.includes('bookings')) {
        return true
      } else {
        return false
      }
    },

    currentUser: {
      get: function() {
        return auth.currentUser
      },
      set: function() {}
    }
  }
}
</script>